module.exports = __webpack_public_path__ + "static/img/product_banner_08_zh.eaaf4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_08_zh.png
// module id = lIZ+
// module chunks = 34